import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import clsx from 'clsx';
import Grid from '@material-ui/core/Grid';
import io from 'socket.io-client';
import mqtt from 'mqtt';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import Map from 'components/map/MapRender';
import TransmissionTowers from 'components/map/TransmissionTowers';
import SidebarMenu from 'components/sidebar/SidebarMenu';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import { mqttUrl, mqttPort, socketUrl } from 'consts/config';
import { hasObjectKeys } from 'utils/main';
import { getJurisdictionExtent } from 'components/map/mapUtils';
import { formStyles } from 'consts/styles/Form';
import socketContext from './socketContext';
import mqttContext from './mqttContext';
import { useStyles } from './ContentWrapperUseStyls';

const ContentWrapper = props => {
  const { map } = props;
  const [socket, setSocket] = React.useState(null);
  const [mqttClient, setMqttClient] = React.useState(null);
  const mappingUavos = useSelector(state => state.mappingUavos);
  const [open, setOpen] = React.useState(false);

  const classes = useStyles();
  const formClasses = formStyles();

  React.useEffect(() => {
    const socketObject = io(socketUrl, {
      query: {
        auth: UserSessionDataHandler.getToken(),
      },
    });
    setSocket(socketObject);
    return () => socketObject.close();
  }, []);

  React.useEffect(() => {
    if (mqttClient) return;
    const mqttObject = mqtt.connect(`wss://${mqttUrl}:${mqttPort}`, {
      username: 'front',
      password: 'NOWE_HASLO',
      clientId: `front_${new Date().getTime()}`,
      protocol: 'wss',
    });

    setMqttClient(mqttObject);

    return () => mqttObject.end();
  }, []);

  React.useEffect(() => {
    if (!mqttClient) return;
    mqttClient.on('connect', () => {
      mqttClient.subscribe('AIRCRAFTS/MERGED');
    });
  }, [mqttClient]);

  React.useEffect(() => {
    if (!hasObjectKeys(map)) return;
    handleCenterToJurysdiction();
    map.getView().on('change', handleExtentChange);
    map.getView().on('change:fitToJurysdiction', handleCenterToJurysdiction);
    setTimeout(function() {
      map.updateSize();
    }, 200);

    return () => cleanup();
  }, [map]);

  const cleanup = () => {
    map.getView().un('change', handleExtentChange);
    map.getView().un('change:fitToJurysdiction', handleCenterToJurysdiction);
  };

  const handleExtentChange = () => {
    updateDashboardExtent();
  };

  const handleCenterToJurysdiction = () => {
    const areaToCenterView = getJurisdictionExtent();
    if (areaToCenterView) {
      map.getView().fit(areaToCenterView);
      updateDashboardExtent();
    }
  };

  const updateDashboardExtent = () => {
    if (!isOnDashboard()) return;
    const extent = map.getView().calculateExtent();
    UserSessionDataHandler.saveDashboardExtent(extent);
  };

  const isOnDashboard = () => {
    if (hasObjectKeys(map))
      setTimeout(function() {
        map.updateSize();
      }, 200);
    return (
      window.location.pathname === '/' ||
      window.location.pathname === '/dashboard'
    );
  };

  const useString = () => {
    const language = useSelector(state => state.language);
    return language.startingMap;
  };

  const subtitles = useString();

  const handleLoadingMap = () => (
    <div
      className={`${classes.ContentWrapper}__loader__map ${formClasses.Form}--flex ${formClasses.Form}--flex--center`}
    >
      <Typography
        variant="h1"
        component="h2"
        gutterBottom
        className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between`}
      >
        <CircularProgress className={`${formClasses.Form}__switch`} size={30} />
        <div>&nbsp;{subtitles}</div>
      </Typography>
    </div>
  );

  return (
    <main
      className={clsx(`${classes.ContentWrapper} ${classes.ContentWrapper}`, {
        [`${classes.ContentWrapper}__shift`]: open,
      })}
    >
      <Grid container>
        <socketContext.Provider value={socket}>
          <mqttContext.Provider value={mqttClient}>
            <Grid item xs={12}>
              {hasObjectKeys(mappingUavos) ? <Map /> : handleLoadingMap()}
            </Grid>
            <TransmissionTowers />
            <SidebarMenu open={open} setOpen={setOpen} />
          </mqttContext.Provider>
        </socketContext.Provider>
      </Grid>
    </main>
  );
};

ContentWrapper.propTypes = {
  map: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  map: state.map,
  mappingUavos: PropTypes.array.isRequired,
});

export default connect(mapStateToProps)(ContentWrapper);
